"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0 10c1 0 2.34-.028 3.448-.252.548-.11 1.131-.287 1.601-.595.46-.303.882-.79.943-1.478l.005.074c.393-.094.807-.236 1.156-.467.437-.29.847-.781.847-1.493 0-1.79-1.78-3.823-5-3.823-1.463 0-2.629.42-3.466 1.046C6.924 13.196 5 15.519 5 17.5c0 .782.452 1.325.95 1.653.47.308 1.054.484 1.602.595C8.66 19.972 10 20 11 20m5.909-3.261c-.37-1.557-1.857-3.131-4.352-3.6.423-.11.903-.173 1.443-.173 2.8 0 4 1.71 4 2.823 0 .483-.45.775-1.091.95M11 19c-2 0-5-.12-5-1.5S7.5 14 11 14s5 2.12 5 3.5-3 1.5-5 1.5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M14 10.739a3 3 0 0 1-1.186-.245c.34-.207.643-.47.894-.776q.143.02.292.02c1.105 0 2-.902 2-2.016a2.01 2.01 0 0 0-1.995-2.017 3.5 3.5 0 0 0-.772-.9q.368-.099.767-.1c1.665 0 3 1.359 3 3.017a3.01 3.01 0 0 1-3 3.017"
  })]
}), 'NewUser');
//# sourceMappingURL=index.js.map